import React from 'react';
import { Card, Typography, Row, Col } from 'antd';
import { getFactorValue } from '../../../Utils/creditBureau';

interface FactorsProps {
    title: string;
    impact: string;
    number: number;
    valueKey: string;
}

const { Title, Text } = Typography;

let statusMapping = new Map<string, string>();
statusMapping.set('Excellent', '#52c41a')
statusMapping.set('Good', '#faad14')
statusMapping.set('Average', '#faad14')
statusMapping.set('Poor', '#faad14')


const data = [
    { title: 'Repayment History', impact: 'High Impact', valueKey: 'repaymentHistory' },
    { title: 'Credit Utilization', impact: 'High Impact', valueKey: 'creditUtilization' },
    { title: 'Credit Age', impact: 'Medium Impact', valueKey: 'creditAge' },
    { title: 'Credit Mix', impact: 'Low Impact', valueKey: 'creditMix' },
    { title: 'Credit Enquires', impact: 'Low Impact', valueKey: 'creditEnquiries' },
];


const Factors: React.FC<FactorsProps> = ({ title, impact, number, valueKey }) => {
    const {status, value} = getFactorValue(valueKey)
    
    const statusColor = statusMapping.get(status);
    return (
        <div>
            <Row align="middle" style={{ marginTop: 16 }}>
                <Col flex="40px">
                    <div style={{
                        width: 24,
                        height: 24,
                        borderRadius: '50%',
                        background: '#1890ff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontSize: 14,
                    }}>
                        {number}
                    </div>
                </Col>
                <Col flex="auto" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                        <Title level={5} style={{ margin: 0 }}>{title}</Title>
                        <Text type="secondary">{impact}</Text>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        <span>{value}</span>
                        <Text strong style={{ color: statusColor, display: 'block' }}>{status}</Text>
                    </div>
                </Col>
            </Row>
        </div>
    );
};


const FactorsView: React.FC = () => {

    return (
        <div>
            <Card style={{ width: '100%', borderRadius: 8 }}>
                <Title level={4}>Important Factors</Title>
                <Text type="secondary">that affect your score</Text>
                <div style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                    {data.map((item, index) => (
                        <Factors
                            title={item.title}
                            impact={item.impact}
                            number={index + 1}
                            valueKey={item.valueKey}
                            key={item.valueKey}
                        />
                    ))}
                </div>
            </Card>
        </div>
    )
};


export default FactorsView